module.exports = __webpack_public_path__ + "static/media/The Spooky-Tempered Clavier.91d530f4.png";